module.exports = __webpack_public_path__ + "img/login-btn.d9004d88.gif";